import AppLayout from "@components/layout/AppLayout"
import StockPriceBox from "@components/dataDisplay/stockPricesBox/StockPricesBox"

async function getServerSideProps() {
  const res = await fetch(
    "https://wp.fuw.ch/wp-json/fuw/v1/marketdata/quotes/121222008-1329-1,998089-4-1,846480-353-814,37504714-353-333,998032-830-814,998407-3127-534,897789-148-1,275000-148-1,2329321-3269-333,BTC,274702-148-333,274207-2913-333"
  )
  const data = await res.json()

  return { props: { data } }
}

const StockPricesBoxPage = ({ data }: any) => {
  return (
    <AppLayout title="Stock Price Box" robots="noindex,nofollow">
      <StockPriceBox data={data} />
    </AppLayout>
  )
}

export { getServerSideProps }
export default StockPricesBoxPage
